module.exports = __webpack_public_path__ + "empty_rights.e51f3c85325a6ed9b9a6021f21732679.svg";